// Copyright (c) 2021, DIALPAD INC., all rights reserved.

import React from 'react';
import {pick} from 'lodash';
import {renderIconByScoreType} from '../../utils';

interface CSATAnswerProps {
    message: any;
}

// Renders the CSAT Answer block with predefined payload values.
export const CSATAnswer = (props: CSATAnswerProps) => {
    const {message} = props;
    const {
        body,
        label_negative: labelNegative,
        label_neutral: labelNeutral,
        label_positive: labelPositive,
    } = pick(message, [
        'body.question',
        'body.value',
        'label_negative',
        'label_neutral',
        'label_positive',
    ]);
    const {value: selectedIndex, question} = body;

    return (
        <div className="message-cx__csat-block">
            <div className="message-cx__csat-title-container">
                <span className="message-cx__csat-title">{question}</span>
            </div>
            <div className="message-cx__csat-icon-container">
                <div className="message-cx__csat-item">
                    <div className="message-cx__csat-icon-wrapper">
                        {renderIconByScoreType(
                            -1,
                            50,
                            'message-cx__csat-icon',
                            selectedIndex === -1,
                        )}
                    </div>
                    <div className="message-cx__csat-label-container">
                        <span className="message-cx__csat-label-negative">
                            {labelNegative}
                        </span>
                    </div>
                </div>
                <div className="message-cx__csat-item">
                    <div className="message-cx__csat-icon-wrapper">
                        {renderIconByScoreType(
                            0,
                            50,
                            'message-cx__csat-icon',
                            selectedIndex === 0,
                        )}
                    </div>
                    <div className="message-cx__csat-label-container">
                        <span className="message-cx__csat-label-neutral">
                            {labelNeutral}
                        </span>
                    </div>
                </div>
                <div className="message-cx__csat-item">
                    <div className="message-cx__csat-icon-wrapper">
                        {renderIconByScoreType(
                            1,
                            50,
                            'message-cx__csat-icon',
                            selectedIndex === 1,
                        )}
                    </div>
                    <div className="message-cx__csat-label-container">
                        <span className="message-cx__csat-label-positive">
                            {labelPositive}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};
